import moment from 'moment';
import { ListTable } from '@/Components/ListTable';
import styles from './ScanWiseTable.module.scss';

const TABLE_COLUMNS = [
	{
		title: 'Activity Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Activity Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Opening Stock',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Packs Created',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Total Stock In',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Total Stock Out',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Closing Stock',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	'Activity Date': 'activityDate',
	'Activity Type': 'activityType',
	'Opening Stock': 'openingStock',
	'Packs Created': 'packsCreated',
	'Total Stock In': 'totalStockIn',
	'Total Stock Out': 'totalStockOut',
	'Closing Stock': 'closingStock',
};

const PackDayWiseTable = (props) => {
	const { data } = props;

	const getActivityTypeColor = (activityType) => {
		if (activityType === 'Stocked in') {
			return 'bg-green-100 text-green-800';
		}
		if (activityType === 'Stocked out') {
			return 'bg-red-100 text-red-800';
		}
		return 'bg-gray-100 text-gray-800';
	};

	const SPECIAL_ITEMS = {
		'Activity Date': (activityDate) => {
			return (
				<div className='w-[120px]'>
					{moment(activityDate)?.format('YYYY-MM-DD')}
				</div>
			);
		},
		'Activity Type': (activityType) => {
			return (
				<span className={`px-2 py-1 rounded text-xs font-medium ${getActivityTypeColor(activityType)}`}>
					{activityType}
				</span>
			);
		},
		'Opening Stock': (value) => {
			return value ?? 0;
		},
		'Packs Created': (value) => {
			return value ?? 0;
		},
		'Total Stock In': (value) => {
			return value ?? 0;
		},
		'Total Stock Out': (value) => {
			return value ?? 0;
		},
		'Closing Stock': (value) => {
			return value ?? 0;
		},
	};

	return (
		<div className={styles.root}>
			<ListTable
				allowCheckList={false}
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={data}
				special={{
					...SPECIAL_ITEMS,
				}}
				fixedHeaderTop={0}
			/>
		</div>
	);
};

export default PackDayWiseTable;
